// src/client/renderer/shaders/cape-shader.glsl.ts
//
// Cape shader GLSL (Plan 13, Task 3.1).
//
// VERTEX: re-exported verbatim from wind-sway.glsl.ts. The cape uses the same
// per-vertex sway deformation as banners/leaves so that all wind-driven geometry
// in the world animates from a single source of truth (changes to wind feel
// propagate everywhere via wind-sway.glsl.ts:1-14).
//
// FRAGMENT: NEW. wind-sway.glsl outputs solid uBaseColor (no texture sampler);
// the cape needs to sample a per-cape PNG (starter / fire / rainbow / etc.).
// Output = texture sample MULTIPLIED by uBaseColor so the cape can be
// optionally tinted (default uBaseColor = white = unmodified texture).
//
// Per Plan 13 Task 3.1 Decision (S#1 fix, see plan preamble Lesson 19):
// reusing the wind-sway VERTEX guarantees the cape's sway curve, stiffness,
// and speed maths match the rest of the world's wind shaders by construction.

export const VERTEX = /* glsl */ `
  uniform float uTime;
  uniform float uIntensity;
  uniform float uSpeed;
  uniform float uStiffness;
  varying vec2 vUv;
  void main() {
    vUv = uv;
    float looseWeight = pow(max(1.0 - uv.y, 0.0), uStiffness);
    float sway = sin(uTime * uSpeed + uv.y * 6.28318) * uIntensity * looseWeight;
    vec3 displaced = position + vec3(sway, 0.0, 0.0);
    gl_Position = projectionMatrix * modelViewMatrix * vec4(displaced, 1.0);
  }
`;

export const FRAGMENT = /* glsl */ `
  uniform vec3 uBaseColor;
  uniform sampler2D uTexture;
  varying vec2 vUv;
  void main() {
    gl_FragColor = texture2D(uTexture, vUv) * vec4(uBaseColor, 1.0);
  }
`;
